<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="height: 80%; width: 40%;">
      <header class="modal-card-head">
        <p class="modal-card-title header">Incentive {{ this.invoice.agency.name }} #{{ this.invoice.id }}</p>
      </header>
      <section class="modal-card-body">
        <div class="container">
          <table class="table is-bordered is-striped is-narrow">
            <thead>
              <tr>
                <th></th>
                <th>Invoice</th>
                <th>Deadline</th>
                <th>Invoice Value</th>
                <th>Incentive Type</th>
                <th>Incentive Value</th>
                <th>Incentive Total</th>
              </tr>
            </thead>
            <tbody v-if="invoices">
              <template v-for="(invoiceIncentive, index) in invoices">
                <tr>
                  <td><input type="checkbox" v-model="invoiceIncentive.selected"/></td>
                  <td>{{ invoiceIncentive.invoice }}</td>
                  <td>{{ invoiceIncentive.deadline }}</td>
                  <td>{{ invoiceIncentive.value }} {{ invoiceIncentive.currency }}</td>
                  <td>{{ parseInt(invoiceIncentive.incentive_type) === 1 ? '%' : '$' }}</td>
                  <td>{{ invoiceIncentive.incentive_value }} {{ invoiceIncentive.currency }}</td>
                  <td>{{ invoiceIncentive.incentive_total }} {{ invoiceIncentive.currency }}</td>
                </tr>
              </template>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="6"><b>Total</b></td>
                <td colspan="1"><b>{{ selectedInvoices }}</b></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-success" @click="save()">Add Icentive</a>
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import message from '../../../../utils/message'
  export default {
    props: {
      context: {
        type: Object
      },
      parentContext: {
        type: Object
      },
      invoice: {
        type: Object,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        invoices: []
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.loadData()
      })
    },
    methods: {
      save () {
        let invoicesTmp = this.invoices
          .filter(invoice => invoice.selected)
        let confirm = window.confirm('Are you sure you want add icentive ' + this.selectedInvoices + ' to invoice #' + this.invoice.id)
        if (confirm) {
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/incentive/' + this.invoice.id, {invoices: invoicesTmp}).then((response) => {
            this.message('success', 'Success', response.body)
            this.close(false, 'ok')
          }, (response) => {
            this.message('danger', 'Error', response.body.message)
            this.close(true, 'ok')
          })
        }
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/V2/invoice/incentive/agency/' + this.invoice.agency.id + '/invoice/' + this.invoice.id).then((response) => {
          this.invoices = response.body
          if (response.body === '') {
            this.close(false)
          } else {
            document.body.appendChild(this.$el)
          }
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.parentContext[this.callback]()
        }
        this.$el.remove()
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: 'Incentive added successfully',
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    computed: {
      selectedInvoices () {
        let total = 0
        let invoicesTmp = this.invoices
          .filter(invoice => invoice.selected)
        invoicesTmp.forEach(invoice => {
          total = parseFloat(invoice.incentive_total) + parseFloat(total)
        })
        return total.toFixed(2)
      }
    },
    components: {
    }
  }
</script>
<style scoped>
  .title {
    text-align: center;
    margin-bottom: 2rem;
  }
  .container {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  .label {
    text-align: center;
  }
  .item {
    text-align: center;
    background-color: white;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    color: #4a4a4a;
    padding: 0.3rem;
    margin: 0.5rem;
    width: 150px;
  }

  .header {
    font-size: 16px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Incentive.vue?ba870286